module.exports = __webpack_public_path__ + "static/tat-35-3b4cfe839f7ac1581fe6b5a150dae21f.jpg";